import actions from './actions'
import mutations from './mutations'

const notification = {
    namespaced: true,
    state: {
        filters: {
            sendTo: 'all',
            phones: ''
        },
        notification: {
            title: '',
            body: '',
            image: ''
        },
        clients: [],
        result: {},
        count: 0,
        normalizePhones: null,
        isLoaded: false
    },
    mutations,
    actions
}

export default notification
